<template>
  <div>
    <QuotationSelectedInsured :form="readonlyForm" @return="previousStep" />
    <QuotationSelectResource
      @resource="submit"
      :model="formResource.resource"
      :list="listResourceType"
    />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotationButton"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </div>
</template>
<script>
import QuotationSelectResource from "../components/QuotationSelectResource";
import QuotationSelectedInsured from "../components/QuotationSelectedInsured";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  name: "QuotationFirstStepResource",
  data: () => ({
    formResource: {}
  }),
  mixins: [QuotationMixin, LoadingRequest],
  components: {
    QuotationSelectResource,
    QuotationSelectedInsured
  },
  mounted() {
    this.formResource = { ...this.form };
  },
  created() {
    this.fetchResource();
  },
  computed: {
    ...mapState("quotation", ["listResourceType"]),
    nextQuotationStep() {
      return {
        name: "quotation step form resource",
        step: 3
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step insured",
        step: 2
      };
    }
  },
  methods: {
    ...mapActions(["hasLoading", "showAlertNotification"]),
    ...mapActions("quotation", ["requestResourceType"]),
    submit(value) {
      this.formResource.resource = value;
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.formResource, this.nextQuotationStep)
      );
    },
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.selectedResouce, this.previousQuotationStep)
      );
    },
    fetchResource() {
      this.withLoading(this.requestResourceType());
    }
  },
  props: {
    form: {
      type: Object
    },
    readonlyForm: {
      type: Object
    }
  }
};
</script>
